import { TFunction } from 'i18next';
import { RSI as RSICalculator } from 'technicalindicators';

import { PriceDataPoint } from '../../../types';
import {
  DataSetSeriesGenerator,
  defaultTooltipForSeriesUsing2DimensionData,
  PriceViewerSeries,
} from './base';
import { fillPriceDates } from './utils';

class RSI extends DataSetSeriesGenerator {
  windowSize: number;
  isSeparateFromPriceChart = true;

  constructor(windowSize: number, t: TFunction) {
    super(t);
    this.windowSize = windowSize;
  }

  getChartName(): string {
    return `${this.t('RSI')}-${this.windowSize}`;
  }

  getSeries(dataPoints: ReadonlyArray<PriceDataPoint>): PriceViewerSeries {
    const allDates = dataPoints.map(item => item.date.toString());
    const dataPointsWithData = dataPoints.filter(
      ({ close }) => close !== undefined
    );
    const dates = dataPointsWithData.map(({ date }) => date) as string[];
    const closePrices = dataPointsWithData.map(({ close }) => close);

    const rsis = RSICalculator.calculate({
      values: closePrices,
      period: this.windowSize,
    });
    // RSI has fewer data points, need to do alignments
    const rsisPadded = [...new Array(dates.length - rsis.length), ...rsis];

    return {
      name: this.getChartName(),
      echartSeries: {
        type: 'line',
        data: fillPriceDates(allDates, rsisPadded, dates),
        symbol: 'none',
      },
      tooltipFormatter: defaultTooltipForSeriesUsing2DimensionData,
    };
  }
}

export default RSI;
